'use client';

import React, { useState, useEffect } from "react";
import { MatchLabel } from "../Match";
import H2HItem from "@/components/client/H2HItem";
import { Image } from "@/lib/target";
import TabPanel from "@/components/client/TabPanel";
import NoData from "@/components/client/NoData";
import HeaderTopRecentMatches from "@/components/server/HeaderTopRecentMatches";
import CollapsiblePanel from "@/components/client/CollapsiblePanel";
import ICON_ARROW_UP_LEAGUES from "@/public/arrow_up_white_leagues.svg";
import ICON_ARROW_DOWN_LEAGUES from "@/public/arrow_down_white_leagues.svg";
import MatchServices from "@/services/MatchServices";
import LoadingInner from "@/app/loadingInner";

const IMAGE_ARROW_DOWN_LEAGUES = ICON_ARROW_DOWN_LEAGUES;
const IMAGE_ARROW_UP_LEAGUES = ICON_ARROW_UP_LEAGUES;

const HeadToHead = ({ matchId }) => {
  const [match, setMatch] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMatchData = async () => {
      try {
        const matchData = await MatchServices.getMatchAnalysis(matchId);
        setMatch(matchData);
      } catch (error) {
        console.error("Error fetching match analysis data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMatchData();
  }, [matchId]);

  if (loading) {
    return (
      <CollapsiblePanel
        title="Thành tích đối đầu 10 trận gần nhất"
        initOpen={true}
        iconUp={IMAGE_ARROW_UP_LEAGUES}
        iconDown={IMAGE_ARROW_DOWN_LEAGUES}
      >
        <LoadingInner/>
      </CollapsiblePanel>
    );
  }

  if (!match || match.length === 0) {
    return (
      <>
        <MatchLabel label={"Thành tích đối đầu 10 trận gần nhất"} />
        <NoData />
      </>
    );
  }

  const { headToHead, homeLastMatches, awayLastMatches, homeId, awayId } =
    match;

  const home = {
    id: homeId,
    name: match.homeTeam.name,
    logo: match.homeTeam.logo,
  };

  const away = {
    id: awayId,
    name: match.awayTeam.name,
    logo: match.awayTeam.logo,
  };

  return (
    <>
      <CollapsiblePanel
        title="Thành tích đối đầu 10 trận gần nhất"
        initOpen={true}
        iconUp={IMAGE_ARROW_UP_LEAGUES}
        iconDown={IMAGE_ARROW_DOWN_LEAGUES}
      >
        {headToHead.length > 0 ? (<TabPanel home={home} away={away} data={headToHead} />) : (
          <NoData message="Không có dữ liệu" />
        )}
      </CollapsiblePanel>
      <CollapsiblePanel
        title="Thành tích 10 trận gần nhất"
        initOpen={true}
        iconUp={IMAGE_ARROW_UP_LEAGUES}
        iconDown={IMAGE_ARROW_DOWN_LEAGUES}
      >
        <div className="flex items-center bg-white-half dark:bg-league-dark px-3 py-2 gap-4 my-3 text-dark-gray dark:text-stroke-o3 text-base font-semibold">
          <div>
            <Image
              alt="Net88"
              src={match.homeTeam.logo}
              width={32}
              height={32}
            />
          </div>
          <div>{match.homeTeam.name}</div>
        </div>
        <HeaderTopRecentMatches />
        {homeLastMatches?.length > 0
          ? homeLastMatches.map((item, index) => (
              <H2HItem key={`home-match-${index}`} match={item} />
            ))
          : null}
        <div className="flex items-center bg-white-half dark:bg-league-dark px px-3 py-2 gap-4 my-3 text-dark-gray dark:text-stroke-o3 text-base font-semibold">
          <div>
            <Image
              alt="Net88"
              src={match.awayTeam.logo}
              width={32}
              height={32}
            />
          </div>
          <div>{match.awayTeam.name}</div>
        </div>
        <HeaderTopRecentMatches />
        {awayLastMatches?.length > 0
          ? awayLastMatches.map((item, index) => (
              <H2HItem key={`away-match-${index}`} match={item} />
            ))
          : null}
      </CollapsiblePanel>
    </>
  );
};

export default HeadToHead;
